/** 安全访问 localStorage（隐私模式 / iframe / SecurityError 时返回 null） */
export const safeLocalStorage = (): Storage | null => {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage
  } catch {
    return null
  }
}

export const safeStorageGetItem = (key: string): string | null => {
  try {
    return safeLocalStorage()?.getItem(key) ?? null
  } catch {
    return null
  }
}

export const safeStorageSetItem = (key: string, value: string): boolean => {
  try {
    safeLocalStorage()?.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export const safeStorageRemoveItem = (key: string): boolean => {
  try {
    safeLocalStorage()?.removeItem(key)
    return true
  } catch {
    return false
  }
}

export const safeStorageGetJSON = <T>(key: string): T | null => {
  const raw = safeStorageGetItem(key)
  if (!raw) return null
  try {
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

export const safeStorageSetJSON = (key: string, value: unknown): boolean => {
  try {
    return safeStorageSetItem(key, JSON.stringify(value))
  } catch {
    return false
  }
}
